import {
  GetBannerGroupsRequest,
  GetBannerGroups,
  GetBannerGroupsBannerSectionsRequest,
  GetBannerGroupsBannerSections,
  PostBannerGroupsRequest,
  PostBannerGroups,
  PostBannerGroupsBannerGroupNoBannerSectionsRequest,
  PostBannerGroupsBannerGroupNoBannerSections,
  PutBannerGroupBannerGroupNoRequest,
  PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest,
  DeleteBannerGroupsBannerGroupNoRequest,
  DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest,
  PutBannerGroupsBannerGroupNoOrderRequest,
  PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrderRequest
} from 'supporter';
import {ActionContext} from 'vuex';
import {api} from '@/api';

interface BannerState {
  bannerGroups: GetBannerGroups[];
  bannerSection: GetBannerGroupsBannerSections;
  groupNo: number;
  createdSectionNo: number;
}

export default {
  namespaced: true,
  state: {
    bannerGroups: [],
    bannerSection: {},
    groupNo: 0,
    createdSectionNo: 0
  },
  actions: {
    getBannerGroups({commit}: ActionContext<BannerState, any>, params: GetBannerGroupsRequest): Promise<void> {
      return api.GetBannerGroups(params).then((res) => {
        commit('SET_BANNER_GROUPS', res.data)
      })
    },
    getBannerGroupsBannerSections({commit}: ActionContext<BannerState, any>, params: GetBannerGroupsBannerSectionsRequest): Promise<any> {
      return api.GetBannerGroupsBannerSections(params).then((res) => {
        commit('SET_SECTION_DATA', res.data)
      })
    },
    postBannerGroups({commit}: ActionContext<BannerState, any>, params: PostBannerGroupsRequest): Promise<any> {
      return api.PostBannerGroups(params).then((res) => {
        commit('SET_GROUP_NO', res.data)
      })
    },
    postBannerSections({commit}: ActionContext<BannerState, any>, params: PostBannerGroupsBannerGroupNoBannerSectionsRequest): Promise<any> {
      return api.PostBannerGroupsBannerGroupNoBannerSections(params).then((res) => {
        commit('SET_CREATED_SECTION_NO', res.data)
      })
    },
    putBannerGroup({commit}: ActionContext<BannerState, any>, params: PutBannerGroupBannerGroupNoRequest): Promise<void> {
      return api.PutBannerGroupBannerGroupNo(params).then((): void => {});
    },
    putBannerSection({commit}: ActionContext<BannerState, any>, params: PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest): Promise<void> {
      return api.PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo(params).then((): void => {});
    },
    putBannerGroupOrder({commit}: ActionContext<BannerState, any>, params: PutBannerGroupsBannerGroupNoOrderRequest): Promise<void> {
      return api.PutBannerGroupsBannerGroupNoOrder(params).then((): void => {});
    },
    putBannerSectionOrder({commit}: ActionContext<BannerState, any>, params: PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrderRequest): Promise<void> {
      return api.PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrder(params).then((): void => {});
    },
    deleteBannerGroup({commit}: ActionContext<BannerState, any>, params: DeleteBannerGroupsBannerGroupNoRequest): Promise<void> {
      return api.DeleteBannerGroupsBannerGroupNo(params).then((): void => {});
    },
    deleteBannerSection({commit}: ActionContext<BannerState, any>, params: DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest): Promise<void> {
      return api.DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNo(params).then((): void => {});
    },
  },
  mutations: {
    SET_BANNER_GROUPS(state: BannerState, data: GetBannerGroups[]): void {
      state.bannerGroups = data
    },
    SET_SECTION_DATA(state: BannerState, data: GetBannerGroupsBannerSections): void {
      state.bannerSection = data
    },
    SET_GROUP_NO(state: BannerState, data: PostBannerGroups): void {
      state.groupNo = data.groupNo
    },
    SET_CREATED_SECTION_NO(state: BannerState, data: PostBannerGroupsBannerGroupNoBannerSections): void {
      state.createdSectionNo = data.createdSectionNo
    }
  },
  getters: {
    bannerGroupList(state: BannerState): GetBannerGroups[]  {
      return state.bannerGroups
    },
    bannerSectionData(state: BannerState): GetBannerGroupsBannerSections {
      return state.bannerSection
    },
    groupNo(state: BannerState): number {
      return state.groupNo
    },
    createdSectionNo(state: BannerState): number {
      return state.createdSectionNo
    }
  }
};